export default {"src":"/_next/static/media/0x30647a72Dc82d7Fbb1123EA74716aB8A317Eac19.e01fd350.svg","height":330,"width":330,"blurWidth":0,"blurHeight":0};